import {
  ADD_TO_BASKET, CLEAR_BASKET,
  FETCH_ORDERS_FAILURE,
  FETCH_ORDERS_REQUEST,
  FETCH_ORDERS_RESPONSE,
  OrderActionTypes,
  OrderState,
} from '../types/Order';

const initialState: OrderState = {
  orders: [],
  basket: [],
  deliveryDates: [],
  isFetchingOrders: false,
  fetchingOrdersFailed: false,
};

const orderReducer = (
  state = initialState,
  action: OrderActionTypes,
): OrderState => {
  switch (action.type) {
    case CLEAR_BASKET:
      return {
        ...state,
        basket: [],
      };
    case ADD_TO_BASKET:
      return {
        ...state,
        basket: state.basket.concat(action.payload.orderLines),
        deliveryDates: action.payload.deliveryDates,
      };
    case FETCH_ORDERS_REQUEST:
      return {
        ...state,
        orders: [],
        deliveryDates: [],
        isFetchingOrders: true,
        fetchingOrdersFailed: false,
      };
    case FETCH_ORDERS_RESPONSE:
      return {
        ...state,
        deliveryDates: [],
        orders: action.payload || [],
        isFetchingOrders: false,
        fetchingOrdersFailed: false,
      };
    case FETCH_ORDERS_FAILURE:
      return {
        ...state,
        orders: [],
        deliveryDates: [],
        isFetchingOrders: false,
        fetchingOrdersFailed: true,
      };
    default:
      return state;
  }
};

export default orderReducer;
